import {
  certificateList,
  cloudServers,
  coloList,
  creditList,
  dedicatedList,
  dnsZoneList,
  domainList,
  home,
  invoiceList,
  orderList,
  otherList,
  partnerLinkList,
  partnerReferralList,
  paymentList,
  planDetail,
  planDevSiteDetail,
  planList,
  planSafeHarbor,
  planSafeHarborStagingEnvironment,
  planSafeHarborStagingEnvironments,
  planSiteDetail,
  planSiteDevEnvs,
  planSiteList,
  profileInfo,
  rdnsRecordList,
  resellerList,
  sharedHostDetail,
  sharedHostSafeHarbor,
  sharedHostSafeHarborStagingEnvironment,
  sharedHostSafeHarborStagingEnvironments,
  supportTicketList,
} from "@/utils/navLinks";
import Breadcrumbs from "@/classes/Breadcrumbs";
import i18n from "@/i18n";
import NavLink from "@/classes/NavLink";

const breadcrumbModes = {
  ANNOUNCEMENTS: () => {
    return new Breadcrumbs({
      links: [home(), new NavLink(i18n.t("global.announcements"), null, "announcements")],
    });
  },
  ANNOUNCEMENT: ({ announcement }) => {
    if (!announcement) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("global.announcements"), null, "announcements"),
        new NavLink(announcement.title, null, "announcement"),
      ],
    });
  },
  DOMAINS: () => {
    return new Breadcrumbs({
      links: [home(), domainList()],
    });
  },
  DOMAIN: ({ domain }) => {
    if (!domain) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        domainList(),
        new NavLink(domain.domain, null, {
          name: "other-detail",
          params: { domainId: domain.id },
        }),
      ],
    });
  },
  FEEDBACK: () => {
    return new Breadcrumbs({
      links: [home(), new NavLink(i18n.t("navigation.feedback"), null, "feedback")],
    });
  },
  OTHER: () => {
    return new Breadcrumbs({
      links: [home(), otherList()],
    });
  },
  OTHER_DETAIL: ({ other }) => {
    if (!other) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        otherList(),
        new NavLink(other.description, null, {
          name: "other-detail",
          params: { otherId: other.id },
        }),
      ],
    });
  },
  PLANS: () => {
    return new Breadcrumbs({
      links: [home(), planList()],
    });
  },
  PLAN_SITES: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [home(), planList(), planDetail(plan.id, plan.nickname), planSiteList()],
    });
  },
  PLAN_STENCILS: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        new NavLink(i18n.t("navigation.stencils"), null, "plan-stencils"),
      ],
    });
  },
  PLAN_ENVIRONMENT: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        new NavLink(i18n.t("navigation.environment"), null, "plan-environment"),
      ],
    });
  },
  PLAN_ACCESS: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        new NavLink(i18n.t("navigation.access"), null, "plan-access"),
      ],
    });
  },
  PLAN_SETTINGS: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        new NavLink(i18n.t("navigation.settings"), null, "plan-settings"),
      ],
    });
  },
  PLAN_DB: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        new NavLink(i18n.t("navigation.db"), null, "plan-db"),
      ],
    });
  },
  PLAN_EMAIL: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        new NavLink(i18n.t("navigation.email"), null, "plan-email"),
      ],
    });
  },
  PLAN_TASKS: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        new NavLink(i18n.t("navigation.tasks"), null, "plan-tasks"),
      ],
    });
  },
  PLAN_CONTAINERS: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        new NavLink(i18n.t("navigation.containers"), null, "plan-containers"),
      ],
    });
  },
  PLAN_PERFORMANCE: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        new NavLink(i18n.t("navigation.performance"), null, "plan-performance"),
      ],
    });
  },
  PLAN_ARCHITECTURE: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        new NavLink(i18n.t("navigation.architecture"), null, "plan-architecture"),
      ],
    });
  },
  PLAN_CONTROL_PANEL: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        new NavLink(i18n.t("navigation.control-panel"), null, "plan-control-panel"),
      ],
    });
  },
  // plan site breadcrumbs
  PLAN_SITE_PERFORMANCE: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.performance"), null, "plan-site-performance"),
      ],
    });
  },
  PLAN_SITE_DOMAIN_OPTIONS: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.domain-options"), null, "plan-site-domain-options"),
      ],
    });
  },
  PLAN_SITE_LOGS: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.logs"), null, "plan-site-logs"),
      ],
    });
  },
  PLAN_SITE_BACKUPS: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.backup"), null, "plan-site-backup"),
      ],
    });
  },
  PLAN_SITE_ACCESS: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.access"), null, "plan-site-access"),
      ],
    });
  },
  PLAN_SITE_SSL: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.ssl"), null, "plan-site-ssl"),
      ],
    });
  },
  PLAN_SITE_VISUAL_COMPARE: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.visual-compare"), null, "plan-site-visual-compare"),
      ],
    });
  },
  PLAN_SITE_CONTROL_PANEL: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.control-panel"), null, "plan-site-control-panel"),
      ],
    });
  },
  PLAN_SITE_DEV_ENVIRONMENTS: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.dev-environments"), null, "plan-site-dev-environments"),
      ],
    });
  },
  PLAN_SITE_ENVIRONMENT: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.environment"), null, "plan-site-environment"),
      ],
    });
  },
  PLAN_SITE_TASKS: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.tasks"), null, "plan-site-tasks"),
      ],
    });
  },
  PLAN_SITE_DB: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.db"), null, "plan-site-db"),
      ],
    });
  },
  PLAN_SITE_EMAIL: ({ plan, site }) => {
    if (!plan || !site) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDetail(site.domain),
        new NavLink(i18n.t("navigation.email"), null, "plan-site-email"),
      ],
    });
  },
  PLAN_SITE_DEV_PERFORMANCE: ({ plan, site, devSite }) => {
    if (!plan || !site || !devSite) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDevEnvs(site.domain),
        planDevSiteDetail(devSite.domain),
        new NavLink(i18n.t("navigation.performance"), null, "plan-site-dev-performance"),
      ],
    });
  },
  PLAN_SITE_DEV_SETTINGS: ({ plan, site, devSite }) => {
    if (!plan || !site || !devSite) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDevEnvs(site.domain),
        planDevSiteDetail(devSite.domain),
        new NavLink(i18n.t("navigation.settings")),
      ],
    });
  },
  PLAN_SITE_DEV_ACCESS: ({ plan, site, devSite }) => {
    if (!plan || !site || !devSite) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDevEnvs(site.domain),
        planDevSiteDetail(devSite.domain),
        new NavLink(i18n.t("navigation.access")),
      ],
    });
  },
  PLAN_SITE_DEV_DOMAIN_OPTIONS: ({ plan, site, devSite }) => {
    if (!plan || !site || !devSite) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDevEnvs(site.domain),
        planDevSiteDetail(devSite.domain),
        new NavLink(i18n.t("navigation.domain-options")),
      ],
    });
  },
  PLAN_SITE_DEV_ENVIRONMENT: ({ plan, site, devSite }) => {
    if (!plan || !site || !devSite) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDevEnvs(site.domain),
        planDevSiteDetail(devSite.domain),
        new NavLink(i18n.t("navigation.environment")),
      ],
    });
  },
  PLAN_SITE_DEV_SSL: ({ plan, site, devSite }) => {
    if (!plan || !site || !devSite) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDevEnvs(site.domain),
        planDevSiteDetail(devSite.domain),
        new NavLink(i18n.t("navigation.ssl")),
      ],
    });
  },
  PLAN_SITE_DEV_LOGS: ({ plan, site, devSite }) => {
    if (!plan || !site || !devSite) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDevEnvs(site.domain),
        planDevSiteDetail(devSite.domain),
        new NavLink(i18n.t("navigation.logs")),
      ],
    });
  },
  PLAN_SITE_DEV_TASKS: ({ plan, site, devSite }) => {
    if (!plan || !site || !devSite) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDevEnvs(site.domain),
        planDevSiteDetail(devSite.domain),
        new NavLink(i18n.t("navigation.tasks")),
      ],
    });
  },
  PLAN_SITE_DEV_DB: ({ plan, site, devSite }) => {
    if (!plan || !site || !devSite) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDevEnvs(site.domain),
        planDevSiteDetail(devSite.domain),
        new NavLink(i18n.t("navigation.db")),
      ],
    });
  },
  PLAN_SITE_DEV_EMAIL: ({ plan, site, devSite }) => {
    if (!plan || !site || !devSite) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDevEnvs(site.domain),
        planDevSiteDetail(devSite.domain),
        new NavLink(i18n.t("navigation.email")),
      ],
    });
  },
  PLAN_SITE_DEV_BACKUPS: ({ plan, site, devSite }) => {
    if (!plan || !site || !devSite) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDevEnvs(site.domain),
        planDevSiteDetail(devSite.domain),
        new NavLink(i18n.t("navigation.backup")),
      ],
    });
  },
  PLAN_SITE_DEV_VISUAL_COMPARE: ({ plan, site, devSite }) => {
    if (!plan || !site || !devSite) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSiteDevEnvs(site.domain),
        planDevSiteDetail(devSite.domain),
        new NavLink(i18n.t("navigation.visual-compare")),
      ],
    });
  },
  PLAN_SAFE_HARBOR: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [home(), planList(), planDetail(plan.id, plan.nickname), planSafeHarbor(plan.id)],
    });
  },
  PLAN_SAFE_HARBOR_MALWARE_SCANS: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        new NavLink(i18n.t("navigation.malware-scans"), null, "plan-safe-harbor-malware-scans"),
      ],
    });
  },
  PLAN_SAFE_HARBOR_THREAT_PROTECTION: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        new NavLink(
          i18n.t("navigation.threat-protection"),
          null,
          "plan-safe-harbor-threat-protection"
        ),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENTS: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        new NavLink(
          i18n.t("navigation.staging-environments"),
          null,
          "plan-safe-harbor-staging-environments"
        ),
      ],
    });
  },
  PLAN_SAFE_HARBOR_MAGENTO_PATCHES: ({ plan }) => {
    if (!plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        new NavLink(i18n.t("navigation.magento-patches"), null, "plan-safe-harbor-magento-patches"),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_PERFORMANCE: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.performance"), null, () => null),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_ACCESS: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.access"), null, () => null),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_DOMAIN_OPTIONS: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.domain-options"), null, () => null),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_SETTINGS: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.settings"), null, () => null),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_ENVIRONMENT: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.environment"), null, () => null),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_SSL: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.ssl"), null, () => null),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_LOGS: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.logs"), null, () => null),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_DB: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.db"), null, () => null),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_TASKS: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.tasks"), null, () => null),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_EMAIL: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.email"), null, () => null),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_BACKUPS: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.backups"), null, () => null),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_CONTAINERS: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.containers"), null, () => null),
      ],
    });
  },
  PLAN_SAFE_HARBOR_STAGING_ENVIRONMENT_CONTROL_PANEL: ({ plan, devSite }) => {
    if (!devSite || !plan) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        planList(),
        planDetail(plan.id, plan.nickname),
        planSafeHarbor(plan.id),
        planSafeHarborStagingEnvironments(plan.id),
        planSafeHarborStagingEnvironment(plan.id, devSite),
        new NavLink(i18n.t("navigation.control-panel"), null, () => null),
      ],
    });
  },
  DNS_ZONES: () => {
    return new Breadcrumbs({
      links: [home(), dnsZoneList()],
    });
  },
  DNS_ZONE: ({ dnsZone }) => {
    if (!dnsZone) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [home(), dnsZoneList(), new NavLink(dnsZone.domain, null, "dns-zone")],
    });
  },
  RDNS_RECORDS: () => {
    return new Breadcrumbs({
      links: [home(), rdnsRecordList()],
    });
  },
  RDNS_RECORD: ({ rdnsRecord }) => {
    if (!rdnsRecord) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [home(), dnsRecordList(), new NavLink(rdnsRecord.target, null, "rdns-record")],
    });
  },
  PARTNER_LINKS: () => {
    return new Breadcrumbs({
      links: [home(), partnerLinkList()],
    });
  },
  PARTNER_LINK: ({ partnerLink }) => {
    if (!partnerLink) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        partnerLinkList(),
        new NavLink(partnerLink.name, null, "partner-link-detail"),
      ],
    });
  },
  PARTNER_REFERRALS: () => {
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.partner-referrals"), null, "partner-referrals"),
      ],
    });
  },
  PARTNER_REFERRAL: ({ partnerReferral }) => {
    if (!partnerReferral) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        partnerReferralList(),
        new NavLink(partnerReferral.id, null, "partner-referral-detail"),
      ],
    });
  },
  PARTNER_CREDITS: () => {
    return new Breadcrumbs({
      links: [home(), new NavLink(i18n.t("navigation.partner-credits"), null, "partner-credits")],
    });
  },
  BILLING_INVOICES: () => {
    return new Breadcrumbs({
      links: [home(), invoiceList()],
    });
  },
  BILLING_INVOICE: ({ invoice }) => {
    if (!invoice) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [home(), invoiceList(), new NavLink(invoice.description, null, "invoice-detail")],
    });
  },
  BILLING_CREDITS: () => {
    return new Breadcrumbs({
      links: [home(), creditList()],
    });
  },
  BILLING_CREDIT: ({ credit }) => {
    if (!credit) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [home(), creditList(), new NavLink(credit.description, null, "credit-detail")],
    });
  },
  BILLING_CREDITCARDS: () => {
    return new Breadcrumbs({
      links: [home(), creditList()],
    });
  },
  BILLING_PAYMENTS: () => {
    return new Breadcrumbs({
      links: [home(), paymentList()],
    });
  },
  BILLING_PAYMENT: ({ invoice }) => {
    if (!invoice) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        paymentList(),
        new NavLink(`${invoice.id} - ${invoice.description}`, null, "invoice-detail"),
      ],
    });
  },
  BILLING_ORDERS: () => {
    return new Breadcrumbs({
      links: [home(), orderList()],
    });
  },
  BILLING_ORDER: ({ order }) => {
    if (!order) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [home(), orderList(), new NavLink(order.identity, null, "order-detail")],
    });
  },
  BILLING_PAYMENT_INFO: () => {
    return new Breadcrumbs({
      links: [home(), new NavLink(i18n.t("navigation.tax"), null, "tax")],
    });
  },
  SHARED_HOSTING: () => {
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
      ],
    });
  },
  SHARED_HOST: ({ sharedHost }) => {
    if (!sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR: ({ sharedHost }) => {
    if (!sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_MALWARE_SCANS: ({ sharedHost }) => {
    if (!sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        new NavLink(
          i18n.t("navigation.malware-scans"),
          null,
          "shared-host-safe-harbor-malware-scans"
        ),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_THREAT_PROTECTION: ({ sharedHost }) => {
    if (!sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        new NavLink(
          i18n.t("navigation.threat-protection"),
          null,
          "shared-host-safe-harbor-threat-protection"
        ),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENTS: ({ sharedHost }) => {
    if (!sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        new NavLink(
          i18n.t("navigation.staging-environments"),
          null,
          "shared-host-safe-harbor-staging-environments"
        ),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_MAGENTO_PATCHES: ({ sharedHost }) => {
    if (!sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        new NavLink(
          i18n.t("navigation.magento-patches"),
          null,
          "shared-host-safe-harbor-magento-patches"
        ),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_PERFORMANCE: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.performance"), null, () => null),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_ACCESS: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.access"), null, () => null),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_DOMAIN_OPTIONS: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.domain-options"), null, () => null),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_SETTINGS: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.settings"), null, () => null),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_ENVIRONMENT: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.environment"), null, () => null),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_SSL: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.ssl"), null, () => null),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_LOGS: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.logs"), null, () => null),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_DB: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.db"), null, () => null),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_TASKS: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.tasks"), null, () => null),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_EMAIL: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.email"), null, () => null),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_BACKUPS: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.backups"), null, () => null),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_CONTAINERS: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.containers"), null, () => null),
      ],
    });
  },
  SHARED_HOST_SAFE_HARBOR_STAGING_ENVIRONMENT_CONTROL_PANEL: ({ sharedHost, devSite }) => {
    if (!devSite || !sharedHost) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.shared-hosting-list"), null, "shared-hosting"),
        sharedHostDetail(sharedHost.id, sharedHost.domain),
        sharedHostSafeHarbor(sharedHost.id),
        sharedHostSafeHarborStagingEnvironments(sharedHost.id),
        sharedHostSafeHarborStagingEnvironment(sharedHost.id, devSite),
        new NavLink(i18n.t("navigation.control-panel"), null, () => null),
      ],
    });
  },
  SSL_CERTIFICATES: () => {
    return new Breadcrumbs({
      links: [home(), certificateList()],
    });
  },
  SSL_CERTIFICATE_ADD: () => {
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.ssl-certificate-add"), null, "certificate-add"),
      ],
    });
  },
  SSL_CERTIFICATE_ADD_WITH_CERT: () => {
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.ssl-certificate-add"), null, "certificate-add"),
      ],
    });
  },
  SUPPORT_TICKETS: () => {
    return new Breadcrumbs({
      links: [home(), supportTicketList()],
    });
  },
  SUPPORT_MIGRATION: () => {
    return new Breadcrumbs({
      links: [
        home(),
        supportTicketList(),
        new NavLink("Request Migration", null, "request-migration"),
      ],
    });
  },
  SUPPORT_TICKET: ({ ticket }) => {
    if (!ticket) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [home(), supportTicketList(), new NavLink(ticket.identity, null, "ticket")],
    });
  },
  PROFILE_INFO: () => {
    return new Breadcrumbs({
      links: [home(), profileInfo()],
    });
  },
  PROFILE_2FA: () => {
    return new Breadcrumbs({
      links: [home(), profileInfo(), new NavLink(i18n.t("navigation.2fa"), null, "2fa")],
    });
  },
  FREE_TRIAL_UPGRADE: () => {
    return new Breadcrumbs({
      links: [
        home(),
        new NavLink(i18n.t("navigation.upgrade-your-plan"), null, "free-trial-upgrade"),
      ],
    });
  },
  CLOUD_SERVERS: () => {
    return new Breadcrumbs({
      links: [home(), cloudServers()],
    });
  },
  CLOUD_SERVER: ({ cloudServer }) => {
    if (!cloudServer) {
      return new Breadcrumbs({ loading: true });
    }
    return new Breadcrumbs({
      links: [
        home(),
        cloudServers(),
        new NavLink(cloudServer.host, null, {
          name: "cloud-server-detail",
          params: { id: cloudServer.id },
        }),
      ],
    });
  },
  CLOUD_SERVER_ADD: () => {
    return new Breadcrumbs({
      links: [home(), cloudServers(), new NavLink(i18n.t("global.add"))],
    });
  },
  CLOUD_SERVER_RESIZE: () => {
    return new Breadcrumbs({
      links: [home(), cloudServers(), new NavLink(i18n.t("global.resize"))],
    });
  },
  DEDICATED_LIST: () => {
    return new Breadcrumbs({
      links: [home(), dedicatedList()],
    });
  },
  COLO_LIST: () => {
    return new Breadcrumbs({
      links: [home(), coloList()],
    });
  },
  RESELLER_LIST: () => {
    return new Breadcrumbs({
      links: [home(), resellerList()],
    });
  },
  TEAM_MEMBERS: () => {
    return new Breadcrumbs({
      links: [home(), new NavLink(i18n.t("global.team-members"))],
    });
  },
  TEAM_PERMISSIONS: () => {
    return new Breadcrumbs({
      links: [home(), new NavLink(i18n.t("global.team-permissions"))],
    });
  },
  API_TOKENS: () => {
    return new Breadcrumbs({
      links: [home(), new NavLink(i18n.t("global.api-tokens"))],
    });
  },
  SSH_KEYS: () => {
    return new Breadcrumbs({
      links: [home(), new NavLink(i18n.t("global.ssh-keys"))],
    });
  },
  REFER_A_FRIEND: () => {
    return new Breadcrumbs({
      links: [home(), new NavLink(i18n.t("global.refer-a-friend"))],
    });
  },
};

export { breadcrumbModes };
